module.exports = __webpack_public_path__ + "static/integral-shop.8cb9687d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/integral-shop.jpg
// module id = 797
// module chunks = 219805994829571